import { styled } from '@mui/material/styles'
import { SxProps } from '@mui/system'

import { theme } from 'src/providers/ThemeProvider'

type HeaderElements = {
  appBar: SxProps
  toolbar: SxProps
  logo: SxProps
  menuBox: SxProps
  user: SxProps
  userAvatar: SxProps
  userAvatarIcon: SxProps
  menuButton: SxProps
  help: SxProps
  userMenu: SxProps
  userMenuName: SxProps
  userMenuCompany: SxProps
  userMenuCollegiate: SxProps
  userMenuSeparator: SxProps
  userMenuConnection: SxProps
  configuration: SxProps
  separator: SxProps
  account: SxProps
  accountWrapperIcon: SxProps
  myAccountText: SxProps
  subMenuItem: SxProps
}

export const headerStyles: HeaderElements = {
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    borderBottom: `1px solid ${theme.colors.white01}`,

    '&.MuiPaper-root': {
      backgroundColor: theme.corporate.secondaryColor,
      color: theme.corporate.primaryColor
    }
  },

  toolbar: {
    height: 66,
    boxShadow: '0px 2px 9px 0px rgba(113, 113, 113, 0.25)',
    padding: theme.spacing(1.5, 3),
    '@media (min-width: 600px)': {}
  },

  logo: {
    flexGrow: 1
  },

  menuBox: {
    margin: theme.spacing(0, '6px')
  },

  user: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: theme.spacing(1),
    position: 'relative',
    cursor: 'pointer'
  },

  userAvatar: {
    position: 'relative',
    width: 32,
    height: 32,
    marginRight: theme.spacing(0.5)
  },

  userAvatarIcon: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 12,
    height: 12,
    display: 'flex'
  },

  menuButton: {
    marginRight: theme.spacing(2)
  },

  help: {
    width: 38,
    height: 38,
    padding: theme.spacing(0.75),
    minWidth: 'unset',
    margin: theme.spacing(0, 0, 0, 1),
    borderRadius: '4px',

    '& .MuiSvgIcon-root': {
      fontSize: 26
    }
  },

  userMenu: {
    '& .MuiPaper-root': {
      width: '240px',
      padding: theme.spacing(2),
      borderRadius: '12px',
      marginTop: '19px',
      boxShadow: '0px 2px 9px 0px rgba(113, 113, 113, 0.25)'
    },

    '& .MuiList-root': {
      padding: 0
    },

    '& .MuiButtonBase-root': {
      width: '100%',
      justifyContent: 'start'
    }
  },

  userMenuName: {
    color: theme.corporate.primaryColor,
    fontFamily: theme.fonts.interFont,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '22px'
  },

  userMenuCompany: {
    color: theme.colors.gray14,
    fontFamily: theme.corporate.primaryFont,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '20px'
  },

  userMenuCollegiate: {
    width: 'fit-content',
    maxWidth: '100%',
    borderRadius: '4px',
    backgroundColor: theme.colors.seaGreen200,
    padding: '2px 8px',
    color: theme.colors.white01,
    fontFamily: theme.fonts.interFont,
    fontSize: 10,
    fontWeight: 400,
    lineHeight: '16px',
    margin: theme.spacing(0.5, 0, 1.5, 0),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },

  userMenuSeparator: {
    width: '100%',
    height: '1px',
    backgroundColor: theme.corporate.primaryColor
  },

  userMenuConnection: {
    '& .MuiButtonBase-root': {
      margin: 0,
      padding: '2px 8px 2px 4px',
      backgroundColor: theme.colors.white01,
      color: theme.colors.gray14,
      fontFamily: theme.corporate.secondaryFont,
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '18px',

      '&:hover': {
        backgroundColor: theme.colors.blue08
      }
    },

    '& .MuiSvgIcon-root': {
      fill: theme.colors.gray14
    }
  },

  configuration: {
    width: '38px',
    minWidth: '38px',
    height: '38px',
    padding: '6px',
    margin: '0 6px',
    borderRadius: '4px',

    '& .MuiSvgIcon-root': {
      fontSize: '26px',
      fill: theme.colors.gray700
    },

    '&.Mui-disabled  .MuiSvgIcon-root': {
      fill: theme.colors.gray16
    }
  },

  separator: {
    width: '1px',
    height: '42px',
    backgroundColor: theme.colors.gray17,
    margin: '0 20px 0 14px'
  },

  account: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '4px',
    padding: '8px 4px',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: theme.colors.blue08
    },

    '& .MuiSvgIcon-root': {
      fontSize: '16px'
    }
  },

  accountWrapperIcon: { margin: '0 3px', height: '16px' },

  myAccountText: {
    fontFamily: theme.fonts.interFont,
    fontSize: '14px',
    fontWeight: 500,
    color: theme.corporate.primaryColor,
    marginLeft: '4px'
  },

  subMenuItem: {
    margin: 0,
    padding: '8px 4px',
    color: theme.colors.gray14,
    fontFamily: theme.corporate.primaryFont,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '-0.14px',
    borderRadius: '4px',

    '& .MuiSvgIcon-root': {
      width: '22px',
      fontSize: '22px',
      marginRight: '4px'
    },

    '& .iconUser': {
      fontSize: '18px'
    },

    '&:hover': {
      backgroundColor: theme.colors.blue08
    },

    // '&:focus': {
    //   backgroundColor: theme.colors.blue07,
    //   boxShadow: '0px 2px 9px 0px rgba(113, 113, 113, 0.25)'
    // },

    '&:active': {
      backgroundColor: theme.colors.blue07
    }
  }
}

export const SpanUsername = styled('span')(({ theme }) => ({
  color: theme.colors.gray700,
  fontFamily: theme.fonts.interFont,
  fontSize: 14,
  fontWeight: 500,
  lineHeight: '22px',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
}))

export const SpanCollegiate = styled('span')(({ theme }) => ({
  color: theme.colors.gray600,
  fontFamily: theme.fonts.interFont,
  fontSize: 12,
  fontWeight: 400,
  lineHeight: '18px',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
}))
